<div class="space-y-8">
  <div>
    <h1 class="text-2xl font-bold text-gray-800">Data Importer</h1>
    <p class="text-gray-600 mt-2">
      Import your data directly from a spreadsheet. Copy the data (including the header row) and paste it into the appropriate text box below.
    </p>
  </div>

  @if(!isSupabaseMode()) {
    <div class="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4" role="alert">
      <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        <div>
          <p class="font-bold">Supabase Not Configured</p>
          <p>Please configure your Supabase settings in <strong>src/firebase.config.ts</strong> and then reload this page.</p>
        </div>
        <button (click)="reloadPage()" class="bg-yellow-500 text-white font-bold py-2 px-4 rounded hover:bg-yellow-600 transition-colors whitespace-nowrap self-start sm:self-center">
          <i class="fa-solid fa-refresh mr-2"></i>Reload Page
        </button>
      </div>
    </div>
  }

  <!-- Product Importer -->
  <div class="bg-white p-6 rounded-md shadow-sm">
    <h2 class="text-xl font-bold text-gray-800 mb-4">Import Products</h2>
    <div class="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mb-4 text-sm">
      <p class="font-bold mb-1">Instructions:</p>
      <p>1. Your data must be in CSV (Comma-Separated Values) format.</p>
      <p>2. The first line must be a header row.</p>
      <p>3. Required columns: <strong>sku, name, category, price, stock</strong>.</p>
      <p>4. Optional columns: <strong>cost, lowStockThreshold, lotNumber, active</strong> (true/false).</p>
    </div>

    <textarea
      [(ngModel)]="productsCsv"
      [disabled]="!isSupabaseMode() || isImportingProducts()"
      rows="10"
      placeholder="Paste product data here (e.g., from Inventory_Master sheet)"
      class="w-full bg-slate-50 border border-gray-300 rounded-md p-2 text-slate-800 font-mono text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all disabled:opacity-50"
    ></textarea>

    <div class="mt-4 flex items-center justify-between">
      <button 
        (click)="importProducts()" 
        [disabled]="!isSupabaseMode() || isImportingProducts() || !productsCsv().trim()"
        class="bg-emerald-600 text-white px-6 py-2 rounded-md hover:bg-emerald-700 transition-colors flex items-center gap-2 disabled:bg-slate-400 disabled:cursor-not-allowed">
        @if (isImportingProducts()) {
          <i class="fa-solid fa-spinner animate-spin"></i>
          <span>Importing...</span>
        } @else {
          <i class="fa-solid fa-upload"></i>
          <span>Import Products</span>
        }
      </button>
      @if (productStatus(); as status) {
        <div [class]="'text-sm font-semibold ' + (status.type === 'success' ? 'text-green-600' : 'text-red-600')">
          {{ status.message }}
        </div>
      }
    </div>
  </div>

  <!-- Customer Importer -->
  <div class="bg-white p-6 rounded-md shadow-sm">
    <h2 class="text-xl font-bold text-gray-800 mb-4">Import Customers</h2>
     <div class="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mb-4 text-sm">
      <p class="font-bold mb-1">Instructions:</p>
      <p>1. Your data must be in CSV format.</p>
      <p>2. The first line must be a header row.</p>
      <p>3. Required columns: <strong>name, nationalId, dateOfBirth, phone</strong>.</p>
      <p>4. `dateOfBirth` should be in YYYY-MM-DD format.</p>
    </div>

    <textarea
      [(ngModel)]="customersCsv"
      [disabled]="!isSupabaseMode() || isImportingCustomers()"
      rows="10"
      placeholder="Paste customer data here (e.g., from Customers1 sheet)"
      class="w-full bg-slate-50 border border-gray-300 rounded-md p-2 text-slate-800 font-mono text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all disabled:opacity-50"
    ></textarea>
    
    <div class="mt-4 flex items-center justify-between">
      <button 
        (click)="importCustomers()" 
        [disabled]="!isSupabaseMode() || isImportingCustomers() || !customersCsv().trim()"
        class="bg-emerald-600 text-white px-6 py-2 rounded-md hover:bg-emerald-700 transition-colors flex items-center gap-2 disabled:bg-slate-400 disabled:cursor-not-allowed">
        @if (isImportingCustomers()) {
          <i class="fa-solid fa-spinner animate-spin"></i>
          <span>Importing...</span>
        } @else {
          <i class="fa-solid fa-upload"></i>
          <span>Import Customers</span>
        }
      </button>
      @if (customerStatus(); as status) {
        <div [class]="'text-sm font-semibold ' + (status.type === 'success' ? 'text-green-600' : 'text-red-600')">
          {{ status.message }}
        </div>
      }
    </div>
  </div>

</div>